<template>
    <div>
        <wp_card style="margin-bottom: 8px;">
            <div slot="head"></div>
            <div><span style="color: black">订单编号：</span>{{orderId}}</div>
            <div><span style="color: black">订单状态：</span>{{orderStatus}}</div>
            <div><span style="color: black">下单时间：</span>{{orderTime}}</div>
            <div v-if="showEstimateFee"><span style="color: black">总预估佣金：￥</span>{{totalEstimateFee}}</div>
            <div><span style="color: black">总付款金额：￥</span>{{totalAmount}}</div>
            <!--        <div>下单设备：</div>-->
            <!--        <div>预估结算时间：</div>-->
<!--            <div><span style="color: black">订单完成时间：</span>{{finishTime}}</div>-->
            <wp_card style="margin-top: 10px; box-shadow: 1px 2px 5px #909090; margin-left: 0px; margin-right: 0px">
                <div slot="head"></div>
                <h3 style="margin-top: -10px">商品</h3>
                <van-divider :style="{borderColor: '#cccccc', 'margin-top': '6px', 'margin-bottom': '6px', 'margin-left': '-10px', 'margin-right': '-10px'}"/>
                <div><span style="color: black">商品名称：</span>{{goodsName}}</div>
                <div><span style="color: black">付款金额：</span>￥{{totalAmount}}</div>
                <div><span style="color: black">数量：</span>{{totalGoodsNum}}</div>

                <div v-if="showEstimateFee"><span style="color: black">佣金比例：</span>{{commissionShare}}%</div>
                <div v-if="showEstimateFee"><span style="color: black">{{feeKey}}：</span>￥{{totalEstimateFee}}</div>

            </wp_card>
        </wp_card>
    </div>

</template>

<script>
    import Vue from 'vue';
    import {Card} from 'iview';
    import wp_card from "../../waps_ui/wp_card";

    Vue.component('Card', Card);
    export default {
        name: "TbOrderDetail",
        components: {wp_card},
        props: {
            goodsWholeInfo: {type: Object, default: null}
        },
        data() {
            return {
                orderId: '订单编号',
                orderStatus: '订单状态',
                orderTime: '下单时间',
                totalEstimateFee: 0,
                totalAmount: 0,//付款总金额
                finishTime: '',//订单完成时间

                skuList: null,//一个订单中，多个商品的信息

                pid: "",

                // goodsName: '商品名称',
                // payAmount: 0,//单个商品付款金额
                // goodsNum: '商品数量',//单个商品的购买数量
                // commissionRate: 0,//佣金比例
                // estimateFee: 0,//单个商品预估佣金
                feeKey: "预估佣金",

                showEstimateFee: true,

                validCode: '-1',
                goodsName: '',
                totalGoodsNum: 0,
                //佣金比例
                commissionShare: 0,
            }
        },
        mounted() {
            this.init();
        },
        watch: {
            goodsWholeInfo() {
                this.init();
            }
        },
        methods: {

            init() {
                if (this.goodsWholeInfo) {
                    this.goodsName = this.goodsWholeInfo.item_title;
                    this.orderId = this.goodsWholeInfo.trade_parent_id;
                    this.orderTime = this.$common.retainTimeMinute(this.goodsWholeInfo.tk_create_time);
                    this.totalAmount = Number(this.goodsWholeInfo.alipay_total_price).toFixed(2);
                    this.totalGoodsNum = this.goodsWholeInfo.item_num;
                    this.finishTime = this.goodsWholeInfo.tk_earning_time;
                    this.pid = this.goodsWholeInfo.pid;

                    this.validCode = this.goodsWholeInfo.tk_status;
                    //淘客订单状态，12-付款，13-关闭，14-确认收货，3-结算成功;不传，表示所有状态
                    switch (this.validCode) {
                        case 12:
                            this.orderStatus = '付款';
                            break;
                        case 13:
                            this.orderStatus = '关闭';
                            break;
                        case 14:
                            this.orderStatus = '确认收货';
                            break;
                        case 3:
                            this.orderStatus = '结算成功';
                            break;
                        default:
                            this.orderStatus = '---';
                    }

                    this.commissionShare = (this.goodsWholeInfo.tk_total_rate * this.$common_tb.commissionRate_pir).toFixed(2);
                    this.totalEstimateFee = this.goodsWholeInfo.pub_share_pre_fee * this.$common_tb.commissionRate_pir;
                    this.totalEstimateFee = this.totalEstimateFee.toFixed(2);
                }

            },

            /**
             * 界面显示的预估佣金比例数值
             */
            showCommissionRate(item){
                let commissionRate = this.getCommissionRate(item)* 100;
                this.$log("commissionRate = " + commissionRate)
                if(commissionRate.toString().indexOf(".") > 0 && commissionRate.toString().split(".")[1].length > 2){
                    return commissionRate.toFixed(2);
                }else{
                    return commissionRate;
                }
            },

            /**
             * 获取实际佣金比例（佣金比例 * 最终比例）除以2
             */
            getCommissionRate(item){
                this.$log("item.finalRate / 100 = " + (item.commissionRate) * (item.finalRate) / 10000/ 2)
                return (item.commissionRate / 100) * (item.finalRate / 100) * this.$common.commissionRate_pir;
            },

            /**
             * 获取支付金额（若已完成，使用实际支付金额）
             */
            getPayAmount(item) {
                if (this.isFinish() && item.actualCosPrice > 0) {
                    return item.actualCosPrice;
                } else {
                    return item.estimateCosPrice;
                }
            },

            /**
             * 获取佣金（若已完成，使用实际佣金值）
             */
            getFee(item) {
                // if (this.isFinish() && item.actualFee > 0) {
                //     // this.feeKey = "实际佣金";
                //     return item.actualFee;
                // } else {
                //     // this.feeKey = "预估佣金";
                //     return item.estimateFee;
                // }
                return (this.getPayAmount(item) * this.getCommissionRate(item)).toFixed(2)
            },

            /**
             * 判断是否是"已完成"（17）状态
             * @return {boolean}
             */
            isFinish() {
                if (this.orderStatus === '已完成') {
                    return true;
                } else {
                    return false;
                }
            },
        }
    }
</script>

<style scoped>

</style>